/* Rugged Print wishlist (2026-10-24). One shared wishlist for every page.
   Storage: localStorage "lumin-wishlist" (same key and item shape the theme's own wishlist uses), so the old Lumin drawer,
   the product page heart and the new header all stay in sync.
   - Header heart count ([data-rp-wl-count]) shows how many items are saved, like the cart count.
   - Heart buttons ([data-wish]) on product cards toggle a product (the card's /products/... link is the key).
   - The wishlist panel ([data-rp-wl-list]) lists saved items with remove buttons.
   Pages that already contain the Lumin wishlist container keep Lumin's own click handling; this file only paints counts there. */
(function(){
  if (window.RPWL) return;
  var KEY = 'lumin-wishlist';
  function read(){ try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch(e){ return []; } }
  function write(a){
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch(e){}
    try { window.dispatchEvent(new StorageEvent('storage', { key: KEY, newValue: JSON.stringify(a) })); } catch(e){}
    paint();
  }
  function money(c){ var d = c / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(m){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[m]; }); }
  function norm(u){ try { var x = new URL(u, location.origin); return x.pathname; } catch(e){ return u; } }
  function has(url){ url = norm(url); return read().some(function(x){ return norm(x.url) === url; }); }
  var hasLumin = function(){ return !!document.querySelector('lumin-wishlist-container'); };

  function toggle(url){
    url = norm(url);
    var list = read();
    if (has(url)) { write(list.filter(function(x){ return norm(x.url) !== url; })); return Promise.resolve(false); }
    return fetch(url + '.js').then(function(r){ if (!r.ok) throw new Error('product ' + r.status); return r.json(); }).then(function(p){
      list = read();
      list.push({ url: url, id: p.id, handle: p.handle, title: p.title, img_src: p.featured_image, img_alt: (p.featured_image && p.featured_image.alt) || p.title,
        compare_at_price: p.compare_at_price, price: p.price, price_varies: p.price_varies, added_at: Date.now() });
      write(list); return true;
    });
  }

  function cardUrl(btn){
    var u = btn.getAttribute('data-product-url'); if (u) return u;
    var c = btn.closest('article,li,.pcard,.pc,[data-h],.i1-card,.lp-pcard') || btn.parentElement;
    var a = c && c.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href') : '';
  }

  function paint(){
    var n = read().length;
    [].slice.call(document.querySelectorAll('[data-rp-wl-count]')).forEach(function(el){ el.textContent = n; el.hidden = n === 0; });
    [].slice.call(document.querySelectorAll('[data-rp-wl-n]')).forEach(function(el){ el.textContent = n ? '(' + n + ')' : ''; });
    [].slice.call(document.querySelectorAll('[data-wish]')).forEach(function(b){
      var u = cardUrl(b); var on = !!u && has(u);
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var box = document.querySelector('[data-rp-wl-list]');
    if (box) {
      var list = read();
      box.innerHTML = list.length ? list.map(function(p){
        return '<div class="rp-wl-item"><a href="' + esc(p.url) + '"><img src="' + esc(p.img_src) + '" alt="" loading="lazy"></a>' +
          '<div><a href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="rp-wl-pr">' + esc(money(p.price)) + (p.price_varies ? ' and up' : '') + '</span></div>' +
          '<button type="button" data-rp-wl-rm="' + esc(p.url) + '" aria-label="Remove ' + esc(p.title) + ' from wishlist">&times;</button></div>';
      }).join('') : '<p class="rp-wl-empty">Nothing saved yet. Tap the heart on any insert to save it here.</p>';
    }
  }

  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-rp-wl-rm]');
    if (rm) { e.preventDefault(); toggle(rm.getAttribute('data-rp-wl-rm')); return; }
    var w = e.target.closest('[data-wish]');
    if (!w || hasLumin()) return;           // Lumin pages keep their own handler
    var u = cardUrl(w); if (!u) return;
    e.preventDefault(); e.stopImmediatePropagation();
    toggle(u).then(function(){ paint(); }).catch(function(){});
  }, true);
  window.addEventListener('storage', function(ev){ if (!ev.key || ev.key === KEY) paint(); });
  window.RPWL = { toggle: toggle, has: has, count: function(){ return read().length; }, paint: paint };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  setTimeout(paint, 1500); setTimeout(paint, 4000);   // after chrome and late-rendered cards mount
})();
